export default __webpack_public_path__ + "static/media/leave.838e4d42.png";